import methods from '@/utils/methods';
import _localStorage from '@/utils/localStorage';
var localStorage = new _localStorage('qiuxiao2');
let _methods = {};
if(methods)_methods=methods;
let {getLoginInfo,getUserInfo} = _methods;
function updateUser(state) {
	return (user) => {
		Object.assign(state.user, user);
		localStorage.setItem('userInfo',JSON.stringify(state.user));
	}
}
function updateNickName(state){
	return (nickName)=>{
		state.user.nickName = nickName;
	}
}
function updateUserName(state){
	return (userName)=>{
		state.user.userName = userName;
	}
}
function getInfo(state){
	return () => {
		return new Promise((resolve, reject) => {
			getLoginInfo().then(async res => {
				const {data} = res
				if (!data) {
					return reject({errType:0,message:'Verification failed, please Login again.'})
				}else if(!data.data&&!data.success){
					return reject({errType:1,message:'login failed'});
				}
				data.data.nickname = data.data.nickname || data.data.nickName;
				data.data.mobile == undefined ? data.data.mobile = '' : '';
				_userAction&&_userAction.updateUser(data.data);
				resolve(data)
			}).catch(error => {
				reject(error)
			})
		})
	}
}

function resetUserStore (state) {
	return (user) => {
		Object.keys(state.user).forEach((key) => {
			if(["admin","isValid"].some(e=>e == key)){
				state.user[key] = false;
			}else{
				state.user[key] = '';
			}
		})
		localStorage.setItem('userInfo',JSON.stringify('{}'));
	}
}
// ---------breadcrumb-----------
function setBreadcrumb(state){
	return (data)=>{
		state.breadcrumb.length = 0;
		data.forEach(e=>state.breadcrumb.push(e));
	}
}
function setBreadcrumbPush(state){
	return (data)=>{
		state.breadcrumb.push(data);
	}
}
function clearBreadcrumb(state){
	return ()=>{
		state.breadcrumb.length = 0;
	}
}
// ---------pageTags-----------
function setPageTags(state){
	return (data)=>{
		state.pageTags.length = 0;
		data.forEach(e=>state.pageTags.push(e));
	}
}
function setPageTagsPush(state){
	return (data)=>{
		state.pageTags.push(data);
	}
}
function removePageTagsFromIndex(state){
	return (index)=>{
		state.pageTags.splice(index,1);
	}
}
function clearPageTags(state){
	return ()=>{
		state.pageTags.length = 0;
	}
}

// --------- currChatUser -----------
function setCurrChatUser(state){
	return (data)=>{
		methods.clearObject(state.currChatUser);
		Object.assign(state.currChatUser,data);
	}
}
function clearCurrChatUser(state){
	return ()=>{
		methods.clearObject(state.currChatUser);
	}
}
// --------- indexContentTabs -----------
function setIndexContentTabs(state){
	return (data)=>{
		state.indexContentTabs.length = 0;
		data.forEach(e=>state.indexContentTabs.push(e));
	}
}
function cleIrIndexContentTabs(state){
	return ()=>{
		state.indexContentTabs.length = 0;
	}
}
// --------- indexLiveTabs -----------
function setIndexLiveTabs(state){
	return (data)=>{
		state.indexLiveTabs.length = 0;
		data.forEach(e=>state.indexLiveTabs.push(e));
	}
}
function cleIrIndexLiveTabs(state){
	return ()=>{
		state.indexLiveTabs.length = 0;
	}
}
// --------- chatroomCommonWords -----------
function setChatroomCommonWords(state){
	return (data)=>{
		state.chatroomCommonWords.length = 0;
		data.forEach(e=>state.chatroomCommonWords.push(e));
	}
}
function cleIrChatroomCommonWords(state){
	return ()=>{
		state.chatroomCommonWords.length = 0;
	}
}
// --------- shieldList -----------
function setShieldList(state){
	return (data)=>{
		state.shieldList.length = 0;
		data.forEach(e=>state.shieldList.push(e));
		localStorage.setItem('shieldList',JSON.stringify(data));
	}
}
function cleIrShieldList(state){
	return ()=>{
		state.shieldList.length = 0;
	}
}
// --------- startUp -----------
function setStartUp(state){
	return (data)=>{
		methods.clearObject(state.startUp);
		Object.assign(state.startUp,data);
	}
}
function cleIrStartUp(state){
	return ()=>{
		methods.clearObject(state.startUp);
	}
}
// -------- notification -------
function setNotification(state){
	return (data)=>{
		state.notification = data;
	}
}
// -------- chatMsgNotice -------
function setChatMsgNotice(state){
	return (data)=>{
		state.chatMsgNotice = data;
	}
}
// ------ custom ---------
function set(state){
	return (key,value)=>{
		state[key] = value;
	}
}
// ------------------------

var _userAction;
let userAction = (state)=>{
	return {
		updateUser: updateUser(state),
		getInfo:getInfo(state),
		resetUserStore:resetUserStore(state),
		updateNickName:updateNickName(state),
		updateUserName:updateUserName(state),
	}
}

var _breadcrumb;
let breadcrumbAction = (state)=>{
	return {
		set:setBreadcrumb(state),
		setPush:setBreadcrumbPush(state),
		clear:clearBreadcrumb(state)
	}
}
var _pageTags;
let pageTagsAction = (state)=>{
	return {
		set:setPageTags(state),
		setPush:setPageTagsPush(state),
		removeFromIndex:removePageTagsFromIndex(state),
		clear:clearPageTags(state)
	}
}
var _currChatUser;
let currChatUserAction = (state)=>{
	return {
		set:setCurrChatUser(state),
		clear:clearCurrChatUser(state)
	}
}
var _indexContentTabs;
let indexContentTabsAction = (state)=>{
	return {
		set:setIndexContentTabs(state),
		clear:cleIrIndexContentTabs(state)
	}
}
var _indexLiveTabs;
let indexLiveTabsAction = (state)=>{
	return {
		set:setIndexLiveTabs(state),
		clear:cleIrIndexLiveTabs(state)
	}
}

var _chatroomCommonWords;
let chatroomCommonWordsAction = (state)=>{
	return {
		set:setChatroomCommonWords(state),
		clear:cleIrChatroomCommonWords(state)
	}
}
var _shieldList;
let shieldListAction = (state)=>{
	return {
		set:setShieldList(state),
		clear:cleIrShieldList(state)
	}
}
var _startUp;
let startUpAction = (state)=>{
	return {
		set:setStartUp(state),
		clear:cleIrStartUp(state)
	}
}
let notification = (state)=>{
	return {
		set:setNotification(state),
	}
}
// ------- chatMsgNotice -------
let chatMsgNotice = (state)=>{
	return {
		set:setChatMsgNotice(state),
	}
}

/**
 * 创建Action
 * @param state
 */
export function createAction(state) {
	let user = userAction(state);
	_userAction = user;
	let breadcrumb = breadcrumbAction(state);
	_breadcrumb = breadcrumb;
	let pageTags = pageTagsAction(state);
	_pageTags = pageTags;
	let currChatUser = currChatUserAction(state);
	_currChatUser = currChatUser;
	let indexContentTabs = indexContentTabsAction(state);
	_indexContentTabs = indexContentTabs;
	let indexLiveTabs = indexLiveTabsAction(state);
	_indexLiveTabs = indexLiveTabs;
	let chatroomCommonWords = chatroomCommonWordsAction(state);
	_chatroomCommonWords = chatroomCommonWords;
	let shieldList = shieldListAction(state);
	_shieldList = shieldList;
	let startUp = startUpAction(state);
	_startUp = startUp;
	return {
		user,
		breadcrumb,
		pageTags,
		currChatUser,
		indexContentTabs,
		indexLiveTabs,
		chatroomCommonWords,
		shieldList,
		startUp,
		notification:notification(state),
		chatMsgNotice:chatMsgNotice(state),
		set:set(state),
	}
}